import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { contactInfo } from '../data/translations';
import { Instagram, Facebook, Send, MessageCircle } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const socialLinks = [
    { icon: Instagram, href: contactInfo.social.instagram, label: 'Instagram' },
    { icon: Facebook, href: contactInfo.social.facebook, label: 'Facebook' },
    { icon: MessageCircle, href: contactInfo.social.whatsapp, label: 'WhatsApp' },
    { icon: Send, href: contactInfo.social.telegram, label: 'Telegram' }
  ];

  const navLinks = [
    { id: 'home', label: t.nav.home },
    { id: 'about', label: t.nav.about },
    { id: 'courses', label: t.nav.courses },
    { id: 'contact', label: t.nav.contact }
  ];

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer */}
        <div className="py-16 grid md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center mb-6">
              {/* Footer Logo */}
              <div className="relative flex items-center">
                <div className="w-11 h-11 bg-gradient-to-br from-sky-400 via-cyan-500 to-blue-500 rounded-xl flex items-center justify-center shadow-lg">
                  <span className="text-white font-black text-xl">i</span>
                </div>
                <div className="ml-3 flex items-baseline">
                  <span className="text-2xl font-extrabold text-white">Info</span>
                  <span className="text-2xl font-extrabold text-sky-400">Lab</span>
                  <span className="ml-1 text-[10px] font-bold text-sky-400/70 uppercase tracking-wider">.az</span>
                </div>
              </div>
            </div>
            <p className="text-slate-400 leading-relaxed mb-6">
              {t.footer.description}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">{t.footer.quickLinks}</h3>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-slate-400 hover:text-sky-400 transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">{t.footer.followUs}</h3>
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-slate-800 rounded-xl flex items-center justify-center hover:bg-sky-500 transition-all duration-300 hover:-translate-y-1"
                  aria-label={social.label}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
            <div className="mt-8">
              <p className="text-slate-400 text-sm">
                {t.contact.email}: {contactInfo.email}
              </p>
              <p className="text-slate-400 text-sm mt-1">
                {t.contact.phone}: {contactInfo.phone}
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between text-sm text-slate-500">
            <p>© {new Date().getFullYear()} InfoLab. {t.footer.rights}</p>
            <p className="mt-2 md:mt-0">infolab.az</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
